export default function Logo({ size = 36 }) {
  return (
    <img
      src="/logo.png"
      alt="Solmas logo"
      data-testid="solmas-logo"
      style={{ width: size, height: "auto" }}
      className="drop-shadow-[0_0_12px_rgba(0,245,212,0.3)]"
    />
  );
}
